import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getRelatedBlogs = async (companyID, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  const {
    data: { data: blogs, total },
  } = await axios.get(`/api/companies/${companyID}/blogs?${queryString}`);

  return { blogs, total };
};

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  includeInactive: false,
  sortBy: 'dateCreated',
  queryKey: ['companies-related-blogs'],
  queryOptions: {},
};

export const useGetRelatedBlogs = (companyID, queryParams = {}) => {
  const { page, limit, search, includeInactive, sortBy, queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    includeinactive: includeInactive,
    sortby: sortBy,
    offset: page * limit,
  };

  return useQuery(
    [...queryKey, companyID],
    () => getRelatedBlogs(companyID, queryStringParams),
    {
      select: ({ blogs, total }) => ({ blogs, total }),
      initialData: { blogs: [], total: 0 },
      ...queryOptions,
    }
  );
};
